import OrderHeader from "../../../components/mandoub-components/order-header/OrderHeader";
import OrderTimeLine from "./OrderTimeLine";
import OrderItems from "../../../components/mandoub-components/order-header/OrderItems";
import { LuBox } from "react-icons/lu";
import { motion } from "framer-motion";
import { staggerChildren, textVariant2 } from "../../../utils/motion";
import { useParams } from "react-router-dom";
import { useFetchData } from "../../../hooks/useFetchData";

function OrderDetails() {
  const { id } = useParams();
  const { data, loading, error } = useFetchData("mandoub/orders?id="+id);

  return (
    <>
    {data &&<div className="df-c det">
  
      <OrderHeader id={data?.order.orderId} order={data?.order} />
      <div className="df wrap res ai-fs">
        <div className="df-c flex1">
        <OrderItems order={data.order} products={data?.order.products[0]} />
        <div className="section-card ord-timeline">
            <OrderTimeLine order={data.order}  />
          </div>
        </div>
        <div 
         variants={staggerChildren}
        className="df-c w-1/3 costumer">
          <div className="section-card cus-info !gap-6 w-100">
            <div variants={textVariant2} className="df-c">
            <div className="title">معلومات العميل</div>
            <div className="df">
              <div className="order-cus-img">
                <img src={data.order.user?.[0]?.image ? data.order.user?.[0]?.image : "/img/default.png"} />
              </div>{" "}
              <div className="df-c g0">
                <div className="font-bold !text-black">{data.order.user?.[0]?.surname} {data.order.user?.[0]?.name}</div>
                <div className="text small-text">البريد الإلكتروني: {data.order.user?.[0]?.email}</div>
                <div className="text">
                  رقم الطلب : <span className="order-id">#{data.order.orderId}</span>
                </div>
              </div>
            </div>
            <div className="header-btns df mx-auto">
             
              <div className="details-btn">
               {data.order?.user?.[0]?.orders.length} الطلبات 
                <LuBox />
              </div>
            </div>
            <hr />
            </div>
            
            <div className="title">تفاصيل التوصيل</div>

            <motion.div variants={textVariant2} className="df-c text-xs">
              <div className="df">
              <span className="w-1/2 text">الولاية:</span>
              <span className=" text-black font-bold">{data?.order?.shippingInfo?.country}</span>

              </div>
              <div className="df">
              <span className="w-1/2 text">محافظة:</span>
              <span className=" text-black font-bold">{data?.order?.shippingInfo?.state}</span>

              </div>
              <div className="df">
              <span className="w-1/2 text">الرمز البريدي:</span>
              <span className=" text-black font-bold">{data?.order?.shippingInfo?.zipCode}</span>

              </div>
            </motion.div>
            <hr />
            <div className="title">معلومات الشحن</div>
            <motion.div variants={textVariant2} className="df-c text-xs">
              <div className="df">
              <span className="w-1/2 text">العنوان:</span>
              <span className=" text-black font-bold">{data?.order?.shippingInfo?.country}, {data?.order?.shippingInfo?.state}, {data?.order?.shippingInfo?.zipCode}</span>

              </div>
              <div className="df">
              <span className="w-1/2 text">الهاتف:</span>
              <span className=" text-black font-bold">{data?.order.phone}</span>

              </div>
            </motion.div>
            <hr />
            <motion.div variants={textVariant2} className="title">معلومات الدفع</motion.div>
            <div className="df-c text-xs">
              <div className="df">
              <span className="text">طريقة الدفع:</span>
              <span className=" text-black font-bold">{data.order.paymentMethod === "نقداً" ? "الدفع عند الاستلام" : "تحويل بنكي"} </span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>}
    {
      loading && "loading ..."
    }
    {
      error && !loading && "error ..."
    }
    </>
  );
}

export default OrderDetails;
